import React, { Fragment, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { Button, Input, message } from 'antd'
import { connect } from 'react-redux'
import { userLogin } from 'request/account'
import { ACCOUNT_NAME_KEY } from 'constants/index'
import { actionCreators } from 'store/index'
import Cookies from 'js-cookie'
import './style.scss'

function Login(props) {
  const { isLogin, setLoginStatus } = props
  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const onLogin = async() => {
    if (!account.trim()) {
      return message.error('手机号不能为空')
    }
    if (!password.trim()) {
      return message.error('密码不能为空')
    }
    setIsLoading(true)
    const { success, message: errMsg, data } = await userLogin({ mobile: account, password })
    setIsLoading(false)
    if (!success) {
      return message.error(errMsg)
    }
    Cookies.set(ACCOUNT_NAME_KEY, data.name, { expires: 1 })
    setLoginStatus(true)
  }
  return (
    <div className="login">
      {isLogin
        ? (
          <Redirect to="/"/>
        ) : (
          <Fragment>
            <div className="content">
              <div className="form">
                <div className="title">东钱湖书记一点通</div>
                <p>
                  <Input
                    size="large"
                    value={account}
                    onChange={e => setAccount(e.target.value)}
                    placeholder="请输入手机号"
                  />
                </p>
                <p>
                  <Input
                    size="large"
                    value={password}
                    type="password"
                    onChange={e => setPassword(e.target.value)}
                    placeholder="请输入密码"
                  />
                </p>
                <p>
                  <Button size="large" className="login-btn" onClick={onLogin} loading={isLoading} type="primary">
                    立即登录
                  </Button>
                </p>
              </div>
            </div>
          </Fragment>
        )}
    </div>
  )
}

export default connect(state => ({
  isLogin: state.getIn(['common', 'isLogin'])
}), dispatch => ({
  setLoginStatus(value) {
    dispatch(actionCreators.setLoginStatus(value))
  }
}))(Login)
